const initialState = {
  data: [],
  current_page: 1,
  last_page: 1,
  per_page: 10,
  total: 0,
  from: 0,
  to: 0,
  loading: false,
  first_page_url: null,
  last_page_url: null,
  next_page_url: null,
  prev_page_url: null,
  path: null,
  links: [],
};

const referralReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_REFERRALS":
      return {
        ...state,
        ...action.payload,
      };
    case "SET_REFERRAL_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

export default referralReducer;
